import { Injectable } from '@angular/core';

import { Mutation, gql } from 'apollo-angular';

import { AddToCartItemPayloadProductArgs, AddToCartPayload, MutationAddToCartArgs } from '@hdms/shared/common-types';

export const addToCartPayloadFragment = gql`
  fragment AddToCartProps on AddToCartPayload {
    cart {
      id
      numberOfItems
    }
    failedItems {
      productId
      quantity
    }
    successfulItems {
      hasAdjustedQuantity
      product(localization: $localization) {
        id
        title
        thumbnail
      }
      quantity
    }
  }
`;

export type AddToCartInputArgs = MutationAddToCartArgs & AddToCartItemPayloadProductArgs;

export interface AddToCartResponse {
  addToCart: AddToCartPayload;
}

@Injectable({
  providedIn: 'root'
})
export class AddToCartGqlService extends Mutation<AddToCartResponse, AddToCartInputArgs> {
  override document = gql`
    mutation AddToCart($input: AddToCartInput!, $localization: LocalizationInput!) {
      addToCart(input: $input) {
        ...AddToCartProps
      }
    }
    ${addToCartPayloadFragment}
  `;
}
